let md = `
### 1
本轮一数字化驱动业务创新与重塑，越来越清晰的聚焦于：数字体验、业务平台化、智能化与云三大领域。尽管不同的行业、组织和企业，对上述领域的表述和内涵界定可能存在差异，或仍有其他特定领域的特征显现，但在我们的观察中，这三大领域，已在跨行业范围内形成了较为广泛的工时。

### 2
零售行业的中台模型，因其本质是对于交易合同及履约的业务抽象，具备较广的适用性，也常被其他行业借鉴和扩展。

### 3
对于金融行业，打造中台能力，无论在银行、证券或是保险等细分行业，均已是高度共识的战略举措之一。当行业越来越重视客户一致性体验时，对于长期掣肘金融行业发展的历史遗留问题，企业也深刻意识到对于此类问题解决的迫切性。如庞大的遗留系统难以响应前端快速的业务创新、客户和业务数据孤岛现象严重、组织架构壁垒高筑等。中台建设北认为是行业普遍认同的求解之道。

### 4
典型行业IT基础设施经历了新一轮的翻新和升级：研发体系的敏捷转型、DevOps体系搭建、大型核心系统的容器化及服务化改造。

### 5
“中台”不是目的，而是手段，“平台化”向业务的再演进，是本轮数字化建设中的重要趋势。

### 6
在我们看来，中台建设的成功，或者“失败”，甚至“去中台化”的声音背后，本质上是一致的商业逻辑：
* 中台建设【不是】广义软件套件实施：复用不是复制，一字之差，却意味着从规划到落地截然不同的方法和实现。
* 中台建设【是】对于企业业务模式端到端的深度分析、建模与复用：中台究竟在复用什么？中台是针对于“商业模式”和“业务模式”的抽象与复用。背后体现的是企业希望通过对于自身商业模式的不断思考与认知，再通过自身业务模式的抽象与沉淀，实现跨地域、跨用户、跨场景、跨领域的扩展和复用，支撑企业业务的快速拓展与创新。

### 7
无论是创新也好，集中管控也好，虽然变化速率不同，但变化始终存在，既然变化不可避免，我们应该将精力投入到应对变化上。

一个清晰的应用边界划分，可以对于业务能力通过对于知识边界的解耦，实现知识的黑盒复用，对于变化的响应非常有帮助。

### 8
运行类场景以业务事务为主线，关注点在于业务事务运作证据的完整性和一致性，以及确保各类数据在各业务单元间高效、准确地传递，实现跨业务单元的事务推进及对于业务溯源的支撑。

### 9
由于分析类场景所要求的方法和技术与运行类场景有着显著的不同，许多企业组建了专职的数据团队，将分析类数据处理工作和其背后的复杂性打包成为一个黑盒，提供端到端的统一的数据类企业级服务与支撑。

这个模式对于业务场景简单的企业环境工作得不错，但对于多业务线、业务平台化的企业环境已初显疲态。一方面，随着 IT 建设加速，数据源和分析类场景的数量激增，对数据类服务的响应力提出了更高要求。另一方面，想要提供高质量的数据类服务，除了分析类数据的专业技能，还要求对于业务场景、现有应用软件的深入理解。如果所有工作仍然只由专职的集中式团队一肩挑，团队带宽的限制必然会拖慢响应力。

因此，我们认为需要探索的是如何适当拆分过于集中的分析类数据处理职责，为集中式的数据团队减负，使其可以将精力投入到高价值的分析类场景中。

### 10
技术架构的挑战和问题：
* 对于架构需求把握不足或者没有架构需求分析意识，过早进入架构设计，导致系统复杂度变高甚至过度设计，为开发落地带来额外的研发成本。
* 架构设计采用的技术和工具过于超前，超出团队成员技术水平，造成落地难度高，新成员上手速度慢，进而对整体进度和实施效果造成影响。
* 架构设计过程时间长，完成后团队就不再愿意对设计方案继续调整和迭代，当技术发展变化很快时，技术架构方案容易进入“完成即落伍”的困局。

### 11
我们需要这样一个体系：
* 系统性的分析架构需求
* 结构化的设计技术方案
* 沉淀可复用的架构经验

### 12
业务平台化的背景和趋势下我们所面临的新问题，也可以映射到企业架构框架元模型的四个层次中：
* 业务架构层：如何抽离多业务线共享能力，以避免重复投资？新业务如何基于企业能力快速组装上线，以支撑业务快速迭代创新？
* 应用架构层：在宏观规划层面，如何有效的划分和组织能力，如何划分IT系统的物理边界，以合理的布局更好地应对变化，在局部设计面，如何最大化复用效果同时，保障对差异化需求的响应力？
* 数据架构层：如何拆分过于集中的分析类数据处理职责，缓解规模化瓶颈？
* 技术架构层：如何在富技术时代进行平台型技术架构设计？

### 13
随着近些年互联网的高速发展，“互联网速度”和“产品为王”的理念直入人心，也导致企业将更多的注意力和资源聚焦于产品（系统）架构层面，<b>关注于如何通过合理的系统架构设计帮助产品快速抢占市场和用户</b>，获得成功。  
这样的产品驱动型策略，切实帮助了许多企业快速通过核心产品的构建和发布，迅速占领市场，获得了阶段性成功。<b>但同样也是因为缺乏对于企业级架构的整体规划与设计</b>，当企业竹间深入到可持续发展的业务持续拓展阶段，产品重复建设、技术与架构大规模异构等问题逐渐显现，给企业带来了越来越大的负担，拖慢了企业持续发展和持续创新的速度。

### 14
架构是系统在其所处环境中的基本概念或属性，体现为它的元素、关系，以及系统设计和演进的原则。

在信息技术领域大体上分为两个粒度，即：系统架构（System Architecture）与企业架构（Enterprise Architecture）。

信息技术领域的架构设计本质是一个认知、抽象与构建的过程，即通过对于物理世界的认知与抽象，识别其中的关键概念及其关系，再通过数字化的手段在数字化世界里重新构建、模拟和还原。

### 15
因此，不破不立，能否在充分吸收经典企业架构框架的优秀思想和最佳实践的前提下，融合最新的企业数字化发展的需求和新技术新趋势，勇于跳出TOGAF 的限制，从问题出发，回归第一性，重新思考和构建一个新的轻量级企业架构框架，切实可以解决企业在向现代企业架构演进过程中面临的问题和挑战，就成为我们重点关注和研究的领域。


### 16
现代企业脚骨框架设计原则
* 战略与业务价值驱动（业务驱动over技术驱动）
* 轻量敏捷话（持续改进over一次做对）
* 可落地（从实践出发over从理论推导）

`

module.exports = {
  title: '《ThoughtWorks现代企业架构白皮书》摘抄',
  author: 'gzshi',
  post: '2022-01-22 15:20',
  tags: ['企业架构', '方法论', '读书笔记'],
  summary: md,
  summaryCompiler: 'md'
}


// WEBPACK FOOTER //
// ./src/blog/20220122_thought_works_snippets/data.js